import { MESSAGE_SENDER } from '../chat-widget/src/constants';
import Message from '../chat-widget/src/components/Widget/components/MainBody/components/Messages/components/Message';
import { ConversationMessage } from './types';

/** Maps a stored conversation message to the shape the vendored chat widget renders. */
export function toWidgetMessage(message: ConversationMessage, unread = false) {
  return {
    type: 'text',
    sender: message.role === 'user' ? MESSAGE_SENDER.CLIENT : MESSAGE_SENDER.RESPONSE,
    showAvatar: true,
    timestamp: new Date(message.createdAt),
    unread,
    customId: message.id,
    text: message.text,
    component: Message,
  };
}
